//@ts-nocheck

import moment from "jalali-moment";
import { DateObject } from "react-multi-date-picker";

// Scroll To Top Handler

export function scrollToTop() {
  const html = document.getElementsByTagName("html")[0];

  html?.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
}

// Get current time in HH:MM:SS format

export function getCurrentTime() {
  const now = new Date();

  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  const formattedDateTime = `${hours}:${minutes}:${seconds}`;
  return formattedDateTime;
}

// Convert date to age

export function getAgeJalali(birthDate) {
  const format = "YYYY-MM-DD";

  const birthMoment = moment(birthDate, format);

  if (!birthMoment.isValid()) {
    return "Invalid date format. Please use 'YYYY-MM-DD'.";
  }

  const today = moment().format("jYYYY/jMM/jDD");
  const todayMoment = moment(today, "jYYYY/jMM/jDD");

  const yearsDifference = todayMoment.jYear() - birthMoment.jYear();

  if (
    todayMoment.jMonth() < birthMoment.jMonth() ||
    (todayMoment.jMonth() === birthMoment.jMonth() &&
      todayMoment.jDate() < birthMoment.jDate())
  ) {
    return yearsDifference - 1;
  }

  return yearsDifference;
}

// Calculate time difference

export function calculateTimeDifference(targetTime) {
  const now = new Date();

  const [targetHours, targetMinutes, targetSeconds] = targetTime
    .split(":")
    .map(Number);

  let targetDate = new Date();
  targetDate.setHours(targetHours, targetMinutes, targetSeconds);

  targetDate.setMinutes(targetDate.getMinutes() + 2);

  let timeDifferenceInSeconds = Math.floor((targetDate - now) / 1000);

  if (timeDifferenceInSeconds <= 0) {
    return "00:00";
  }

  const minutes = Math.floor(timeDifferenceInSeconds / 60);
  const seconds = timeDifferenceInSeconds % 60;

  const formattedMinutes = minutes.toString().padStart(2, "0");
  const formattedSeconds = seconds.toString().padStart(2, "0");

  return `${formattedMinutes}:${formattedSeconds}`;
}

// Date Format to Fa

export const formateDate = (date: string) => {
  const jalaliDate = moment(date).locale("fa").format("jYYYY/jMM/jDD");
  return jalaliDate;
};

// Gender converter

export const genderConverter = (gender: string) => {
  switch (gender) {
    case "MALE":
      return "مرد";
    case "FEMALE":
      return "زن";
    default:
      return "نامشخص";
  }
};

// Test type converter

export const typeConverter = (test: any) => {
  switch (test) {
    case "Blood":
      return "BLOOD_TEST";
    case "Urine":
      return "URINE_TEST";
    case "Stool":
      return "STOOL_TEST";
    default:
      return "";
  }
};

// Test type Persian converter

export const typePersianConverter = (test: any) => {
  switch (test) {
    case "BLOOD_TEST":
      return "آزمایش خون";
    case "URINE_TEST":
      return "آزمایش ادرار";
    case "STOOL_TEST":
      return "آزمایش مدفوع";
    default:
      return "آزمایش";
  }
};

// Convert Persian Digits To English

export function convertPersianDigitsToEnglish(num) {
  const id = {
    "۰": "0",
    "۱": "1",
    "۲": "2",
    "۳": "3",
    "۴": "4",
    "۵": "5",
    "۶": "6",
    "۷": "7",
    "۸": "8",
    "۹": "9",
  };
  return num
    ? num.toString().replace(/[^0-9.]/g, function (w) {
        return id[w] || w;
      })
    : null;
}

// Date Format To Jalali

export const formateDateToJalali = (date: string) => {
  const jalaliDate = date
    ? moment(date).locale("fa").format("jYYYY/jMM/jDD")
    : null;
  return jalaliDate;
};

// Date Format to Gregorian
export const formateStringDateToGregorian = (selectedDate: any) => {
  const gregorianDate = moment
    .from(selectedDate, "fa", "YYYY/MM/DD")
    .format("YYYY-MM-DD");
  return gregorianDate;
};

// Format date object to gregorian date
export const formateDateToGregorian = (selectedDate: any) => {
  const gregorianDate = new DateObject(selectedDate)
    //@ts-ignore
    .convert("gregorian")
    .toDate();
  const formattedDate = `${gregorianDate.getFullYear()}-${(
    gregorianDate.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${gregorianDate.getDate().toString().padStart(2, "0")}`;
  return formattedDate;
};

// Range Functions
export function normalizeValue(
  value: number,
  min: number,
  max: number
): number {
  if ((max && min === null) || (min && max === null)) {
    return `_${value}`;
  }

  // const valueOrder = Math.floor(Math.log10(value));
  // const rangeOrder = Math.floor(Math.log10((min + max) / 2));
  // const scaleFactor = Math.pow(10, rangeOrder - valueOrder);
  return value;
}
// export function factorConvertor(
//   normalizedValue: number,
//   range: RangeType
// ): PositionResult {
//   const interpolate = (
//     value: number,
//     min: number,
//     max: number,
//     startPercent: number,
//     endPercent: number
//   ): number => {
//     const normalized = (value - min) / (max - min);
//     return startPercent + normalized * (endPercent - startPercent);
//   };

//   let percent = 0;
//   let title = "";
//   let color = "";

//   if (
//     (range?.min_value === null || normalizedValue >= range?.min_value) &&
//     (range?.low_normal === null || normalizedValue <= range?.low_normal)
//   ) {
//     percent = interpolate(
//       normalizedValue,
//       range?.min_value ?? Number.NEGATIVE_INFINITY,
//       range?.low_normal ?? Number.POSITIVE_INFINITY,
//       20,
//       40
//     );
//     title = "نرمال";
//     color = "#faaa00";
//   } else if (
//     (range?.low_normal === null || normalizedValue >= range?.low_normal) &&
//     (range?.high_normal === null || normalizedValue <= range?.high_normal)
//   ) {
//     percent = interpolate(
//       normalizedValue,
//       range?.low_normal ?? Number.NEGATIVE_INFINITY,
//       range?.high_normal ?? Number.POSITIVE_INFINITY,
//       40,
//       60
//     );
//     title = "بهینه";
//     color = "#1abf98";
//   } else if (
//     (range?.high_normal === null || normalizedValue >= range?.high_normal) &&
//     (range?.max_value === null || normalizedValue <= range?.max_value)
//   ) {
//     percent = interpolate(
//       normalizedValue,
//       range?.high_normal ?? Number.NEGATIVE_INFINITY,
//       range?.max_value ?? Number.POSITIVE_INFINITY,
//       60,
//       80
//     );
//     title = "نرمال";
//     color = "#faaa00";
//   } else if (range?.max_value !== null && normalizedValue > range?.max_value) {
//     percent = 90;
//     title = "بالا";
//     color = "#fa6e00";
//   } else {
//     percent = 10;
//     title = "پایین";
//     color = "#fa6e00";
//   }

//   return { percent, color, title };
// }

// Return test factor data based on status

export const factor_convertor = (status: string) => {
  if (status === "L") {
    return {
      text: "پایین",
      color: "#fa6e00",
      position: 10,
    };
  } else if (status === "LN") {
    return {
      text: "نرمال",
      color: "#faaa00",
      position: 30,
    };
  } else if (status === "N") {
    return {
      // text: "بهینه",
      text: "نرمال",
      color: "#1abf98",
      position: 50,
    };
  } else if (status === "HN") {
    return {
      text: "نرمال",
      color: "#faaa00",
      position: 75,
    };
  } else if (status === "H") {
    return {
      text: "بالا",
      color: "#fa6e00",
      position: 90,
    };
  } else if (status?.toLowerCase() === "normal") {
    return {
      text: "نرمال",
      color: "#1abf98",
      position: 30,
    };
  } else if (status?.toLowerCase() === "abnormal") {
    return {
      text: "غیرمعمولی",
      color: "#fa6e00",
      position: 30,
    };
  }

  return {
    text: "نامشخص",
    color: "#000",
    position: 0,
  };
};

export function categorizeAgeData(data) {
  // Define age ranges
  const ageRanges = [
    { range: "0-5", min: 0, max: 5 },
    { range: "5-10", min: 5, max: 10 },
    { range: "10-15", min: 10, max: 15 },
    { range: "15-20", min: 15, max: 20 },
    { range: "25-30", min: 25, max: 30 },
    { range: "35-40", min: 35, max: 40 },
    { range: "45-50", min: 45, max: 50 },
    { range: "55-60", min: 55, max: 60 },
    { range: "60-65", min: 60, max: 65 },
    { range: "65-70", min: 65, max: 70 },
    { range: ">70", min: 70, max: Infinity },
  ];

  // Create a result object for storing the categorized counts
  const result = {
    "0-5": 0,
    "5-10": 0,
    "10-15": 0,
    "15-20": 0,
    "25-30": 0,
    "35-40": 0,
    "45-50": 0,
    "55-60": 0,
    "60-65": 0,
    "65-70": 0,
    ">70": 0,
  };

  // Iterate through the data and categorize it based on age
  data
    .filter((dataItem) => dataItem.age_users)
    .forEach((item) => {
      const { age_users, count } = item;

      if (age_users === null || age_users === undefined) {
        result["نامشخص"] += count;
      } else {
        for (const range of ageRanges) {
          if (age_users >= range.min && age_users < range.max) {
            result[range.range] += count;
            break;
          }
        }
      }
    });

  return result;
}

export const analysisFeedbackTypeConverter = (type: string) => {
  switch (type) {
    case "Incorrect_extraction":
      return "اطلاعات آزمایش به درستی استخراج نشده بود";
    case "incompleteness_analysis":
      return "تحلیل آزمایش به اندازه کافی کامل نبود";
    case "Inaccuracy_analysis":
      return "نتیجه تحلیل آزمایش درست نبود";
  }
};
